import React from 'react';
const AccountInfoStep = ({
  onNext,
  onPrev
}) => {
  const handleSubmit = e => {
    e.preventDefault();
    onNext();
  };
  return <div data-id="element-577">
      <h2 className="text-xl font-semibold mb-6" data-id="element-578">Account Information</h2>
      <form onSubmit={handleSubmit} data-id="element-579">
        <div className="space-y-6" data-id="element-580">
          <div data-id="element-581">
            <label htmlFor="bankName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-582">
              Bank Name
            </label>
            <input type="text" id="bankName" name="bankName" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter your bank name" required data-id="element-583" />
          </div>
          <div data-id="element-584">
            <label htmlFor="accountNumber" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-585">
              Account Number / IBAN
            </label>
            <input type="text" id="accountNumber" name="accountNumber" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter your account number or IBAN" required data-id="element-586" />
          </div>
          <div data-id="element-587">
            <label htmlFor="branchName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-588">
              Branch Name
            </label>
            <input type="text" id="branchName" name="branchName" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter your bank branch name" required data-id="element-589" />
          </div>
          <div data-id="element-590">
            <label htmlFor="paymentMethods" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-591">
              Payment Methods
            </label>
            <p className="text-sm text-gray-500 mb-2" data-id="element-592">
              Select all payment methods you want to accept
            </p>
            <div className="space-y-2" data-id="element-593">
              <label className="flex items-center" data-id="element-594">
                <input type="checkbox" name="visa" className="h-4 w-4 text-blue-600 focus:ring-blue-500" data-id="element-595" />
                <span className="ml-2" data-id="element-596">Visa</span>
              </label>
              <label className="flex items-center" data-id="element-597">
                <input type="checkbox" name="mastercard" className="h-4 w-4 text-blue-600 focus:ring-blue-500" data-id="element-598" />
                <span className="ml-2" data-id="element-599">Mastercard</span>
              </label>
              <label className="flex items-center" data-id="element-600">
                <input type="checkbox" name="rtp" className="h-4 w-4 text-blue-600 focus:ring-blue-500" data-id="element-601" />
                <span className="ml-2" data-id="element-602">Request to Pay (RTP)</span>
              </label>
              <label className="flex items-center" data-id="element-603">
                <input type="checkbox" name="qr" className="h-4 w-4 text-blue-600 focus:ring-blue-500" data-id="element-604" />
                <span className="ml-2" data-id="element-605">QR Code Payments</span>
              </label>
              <label className="flex items-center" data-id="element-606">
                <input type="checkbox" name="other" className="h-4 w-4 text-blue-600 focus:ring-blue-500" data-id="element-607" />
                <span className="ml-2" data-id="element-608">Other</span>
              </label>
            </div>
          </div>
          <div className="pt-4 flex justify-between" data-id="element-609">
            <button type="button" onClick={onPrev} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-610">
              Back
            </button>
            <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-611">
              Continue to Partner Information
            </button>
          </div>
        </div>
      </form>
    </div>;
};
export default AccountInfoStep;